export enum FlightType {
  RETURN = "rt",
  ONE_WAY = "ow",
}
